import { BuildingOwnerShipInfo } from "shared/types/ownership-info";

export const calculateInsuranceDotValues = (buildingOwnershipInfo: BuildingOwnerShipInfo) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    if (buildingOwnershipInfo) {
        if (buildingOwnershipInfo.buildingInsuredValue && buildingOwnershipInfo.buildingInsuredValue > 0) {
            dotValues.green.count++;
            dotValues.green.labels.push("Verzekerde waarde ingevuld");
        } else if (!buildingOwnershipInfo.buildingInsuredValue || buildingOwnershipInfo.buildingInsuredValue === 0) {
            dotValues.red.count++;
            dotValues.red.labels.push("Verzekerde waarde niet ingevuld");
        }
    }

    return dotValues;
};
